import { render, staticRenderFns } from "./CompanyMenu.vue?vue&type=template&id=5a3433a2&scoped=true"
import script from "./CompanyMenu.vue?vue&type=script&lang=js"
export * from "./CompanyMenu.vue?vue&type=script&lang=js"
import style0 from "./CompanyMenu.vue?vue&type=style&index=0&id=5a3433a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3433a2",
  null
  
)

export default component.exports